import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import get from 'lodash/get';

import VisitRequest from './visit-request';
import rsvpRepVisitMutation from '../../mutations/HighSchool/rsvpRepVisit';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import { withEnabledFeatures } from '../../utils/features';
import { query as AvailabilitySlots } from '../AvailabilitySlots';

const query = gql`
  query VisitRequest($id: ID!) {
    node(id: $id) {
      id
      ... on RepVisitsDay {
        date
        timezone
        status
        highSchool {
          id
          name
        }
        appointments {
          id
          startTime
          startISOTime
          endISOTime
          status
          userBookingStatus
          visitLocationType
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id }) => ({
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  }),
});

const mutateRSVPRepVisit = graphql(rsvpRepVisitMutation, {
  name: 'rsvpRepVisit',
  options: {
    refetchQueries: (mutationResult) => {
      const date = get(mutationResult, 'data.rsvpRepVisit.repVisit.date');
      return ['RepVisitsOverview', 'AvailabilityCalendar', 'RepVisitsYourSchedule', {
        query: AvailabilitySlots,
        variables: {
          fromDate: date,
          toDate: date,
        },
      }];
    },
  },
});

export default withEnabledFeatures(SimpleGraphQLComponent(
  graphqlData, mutateRSVPRepVisit,
)(VisitRequest));
